import React from "react";
import { Helmet } from "react-helmet";
import { useState } from "react";
import ImageGalleryComponent from "../Common/Gallery";

const AapolloMultimediaProgram = () => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const image = [
        'https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/apollo-multimedia-Nov-2017-2-1.jpg',
        'https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/apollo-multimedia-Nov-2017-1-1.jpg'
    ];
    return (
        <>
            < Helmet >
                <title>Aapollo Multimedia Program - Cope with Cancer</title>

                <link rel="canonical" href="https://www.copewithcancer.org/events-page/aapollo-multimedia-program" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Aapollo Multimedia Program - Cope with Cancer" />
                <meta property="og:url" content="https://www.copewithcancer.org/events-page/aapollo-multimedia-program" />
                <meta property="og:site_name" content="Cope with Cancer" />
                <meta property="article:publisher" content="https://www.facebook.com/copewithcancer/" />
                <meta property="og:image" content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/apollo-multimedia-Nov-2017.jpg" />
                {/* <meta property="og:image" content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/apollo-multimedia-Nov-2017-2-1.jpg" />
                <meta property="og:image" content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/apollo-multimedia-Nov-2017-1-1.jpg" /> */}
                <meta property="og:image:width" content="400" />
                <meta property="og:image:height" content="532" />
                <meta name="twitter:card" content="summary" />
                <meta name="twitter:title" content="Aapollo Multimedia Program - Cope with Cancer" />
                <meta name="twitter:site" content="@copewithcancer" />
                <meta name="twitter:image" content="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/apollo-multimedia-Nov-2017.jpg" />
                <meta name="twitter:creator" content="@copewithcancer" />
                <meta property="DC.date.issued" content="2017-10-14T11:12:45+00:00" />
            </Helmet >
            <div className="topspace">
                <div className="text-center">
                    <div className="awarenessprogrambanner"></div>
                    {/* <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/awareness_program_banner.jpg" alt="Awareness Program" className="w-100" ></img> */}
                    {/* <h1 class="bannerHeading">Awareness Program</h1> */}
                </div>
                <div className="contentBox">
                    <div className="container">
                        <p className="Bold18 titleWidth">Aapollo Multimedia Supported Madat Trust Activities to Bring About an Awareness Through a Musical Program.</p>
                        <div className="row text-center">
                            <div className="col-md-12 mb20">
                                <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/apollo-multimedia-Nov-2017-2-1.jpg" alt="copewithcancer" width="50%" className="pointer media100"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    onClick={() => setSelectedImageIndex(0)} />
                            </div>
                            <div className="col-md-12">
                                <img src="https://cwc-react.s3.ap-south-1.amazonaws.com/img/Events/apollo-multimedia-Nov-2017-1-1.jpg" alt="copewithcancer" width="50%" className="pointer media100"
                                    data-toggle="modal"
                                    data-target="#exampleModal"
                                    onClick={() => setSelectedImageIndex(1)} />
                            </div>
                            <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog modalDialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header modalHeader">
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        {console.log(selectedImageIndex)}
                                        <div class="modal-body modalHeight pt0">
                                            <ImageGalleryComponent
                                                images={image}
                                                showThumbnails={false} // Hide thumbnails in popup
                                                showPlayButton={false}
                                                currentImageIndex={selectedImageIndex}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AapolloMultimediaProgram;